export default "__VITE_ASSET__DBukefTR__"